import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const RatingStarEmpty: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 24 24"
      fill="none"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M17.9401 22C17.793 22.0013 17.6477 21.9672 17.5166 21.9006L12 19.0332L6.48341 21.9006C6.33637 21.975 6.17164 22.0078 6.00721 21.9953C5.84277 21.9828 5.68494 21.9255 5.55093 21.8296C5.41718 21.733 5.31304 21.6011 5.25018 21.4488C5.18732 21.2965 5.16822 21.1298 5.19502 20.9673L6.21648 14.8386L1.76762 10.4807C1.64921 10.3652 1.56547 10.219 1.52584 10.0587C1.48621 9.89833 1.49226 9.73012 1.54331 9.57301C1.59435 9.41589 1.68837 9.2761 1.81477 9.16937C1.94117 9.06264 2.09494 8.99321 2.25877 8.9689L8.41956 8.03202L11.2028 2.48885C11.2773 2.34182 11.3913 2.21829 11.532 2.13199C11.6728 2.04569 11.8348 2 12 2C12.1652 2 12.3272 2.04569 12.468 2.13199C12.6087 2.21829 12.7227 2.34182 12.7972 2.48885L15.5804 8.03202L21.7412 8.9547C21.9051 8.97902 22.0588 9.04845 22.1852 9.15518C22.3116 9.26191 22.4056 9.4017 22.4567 9.55881C22.5077 9.71593 22.5138 9.88413 22.4742 10.0445C22.4345 10.2048 22.3508 10.351 22.2324 10.4665L17.7942 14.8386L18.8157 20.9673C18.8368 21.0942 18.83 21.2241 18.7958 21.3482C18.7616 21.4722 18.7007 21.5873 18.6174 21.6855C18.5342 21.7838 18.4304 21.8628 18.3135 21.9171C18.1965 21.9714 18.0691 21.9996 17.9401 22ZM12 17.1488C12.1428 17.1492 12.2834 17.1845 12.4093 17.2517L16.7692 19.5052L15.9648 14.6753C15.9417 14.5351 15.9526 14.3913 15.9965 14.2561C16.0405 14.1209 16.1163 13.9982 16.2175 13.8981L19.7161 10.4594L14.8615 9.73188C14.7199 9.71052 14.5855 9.65553 14.4697 9.57153C14.3538 9.48754 14.26 9.377 14.196 9.24925L12 4.87007L9.80404 9.24925C9.74003 9.377 9.64615 9.48754 9.53032 9.57153C9.41449 9.65553 9.28011 9.71052 9.13849 9.73188L4.28389 10.4594L7.78248 13.8981C7.88373 13.9982 7.9595 14.1209 8.00346 14.2561C8.04742 14.3913 8.0583 14.5351 8.03517 14.6753L7.23082 19.5052L11.5907 17.2588C11.716 17.1891 11.8566 17.1513 12 17.1488Z"
        fill="#FFCB03"
      />
    </svg>
  );
};

export default RatingStarEmpty;
